import { useState } from 'react';
import { AxiosRequestConfig } from 'axios';
import { fetchInitials, saveOrder, uploadDesignFile, fetchBuckets, fetchBucketFile } from 'api';
import { IData } from 'types';
import useAxios from 'hooks/useAxios';

const useFetchInitials = () => {
  const [request, { loading, error }] = useAxios();

  const handleFetchInitials = async (data: IData) => {
    const initials = await request(fetchInitials(data));

    return initials;
  };

  return [handleFetchInitials, { loading, error }];
};

const useSaveOrder = () => {
  const [request, { loading, error }] = useAxios();

  const handleSaveOrder = async (data: IData) => {
    const initials = await request(saveOrder(data));

    return initials;
  };

  return [handleSaveOrder, { loading, error: error?.data?.message }] as const;
};

const useUploadDesignFile = () => {
  const [request, { loading, error }] = useAxios<string>();
  const [progress, setProgress] = useState(0);

  const handleUploadDesign = async (data: IData | FormData) => {
    const status = await request(
      uploadDesignFile(data, {
        onUploadProgress: (progressEvent: Parameters<NonNullable<AxiosRequestConfig['onUploadProgress']>>[0]) =>
          setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total)),
      })
    );

    setProgress(0);

    return status;
  };

  return [handleUploadDesign, { loading, progress, error: error?.data?.message }] as const;
};

const useFetchBuckets = () => {
  const [request, { loading, error }] = useAxios();

  const handleFetchBuckets = async () => {
    const buckets = await request(fetchBuckets());

    return buckets;
  };

  return [handleFetchBuckets, { loading, error }] as const;
};

const useBucketFile = () => {
  const [request, { loading, error, data }] = useAxios();

  const handleFetchBucketFile = async (id: string | number, fileName: IData) => {
    const bucketFile = await request(fetchBucketFile(id, fileName));
    return bucketFile;
  };

  return [handleFetchBucketFile, { loading, error, data }] as const;
};

export { useFetchInitials, useSaveOrder, useUploadDesignFile, useFetchBuckets, useBucketFile };
